<template>
  <grid horizontal="center" flat wrap="wrap">
    <grid-item
      v-for="(item, index) in items"
      :key="index"
      :size="'1/' + numberOfFields"
      :rwd="{ compact: '1/' + numberOfFields / 2 }"
    >
      <div class="input-wrapper">
        <input
          class="input"
          :disabled="disabled"
          autocomplete="off"
          type="text"
          v-model="items[index]"
          v-validate.initial="'required|number'"
          @input="jump($event)"
          @keyup.delete="handleDelete($event)"
          :tabindex="index"
          :name="'code_input_' + index"
          :min="min"
          :max="max"
          :maxlength="maxLength"
          v-focus="index === 0"
        />
      </div>
    </grid-item>
  </grid>
</template>

<script>
const focus = {
  params: ["exec"],
  inserted(el, binding) {
    if (binding.value) {
      setTimeout(() => {
        el.focus();
      }, 0);
    }
  }
};

export default {
  name: "auth-code-input",
  directives: { focus },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    numberOfFields: {
      type: Number,
      default: 1
    },
    maxLength: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: 9
    },
    min: {
      type: Number,
      default: 1
    }
  },
  computed: {
    items() {
      let array = [];

      for (var i = 0; i < this.numberOfFields; i++) {
        array[i] = "";
      }

      return array;
    }
  },
  methods: {
    handleDelete(evt) {
      this.jump(evt, evt.target.value);
    },
    jump(evt, noFocusSelect) {
      if (evt.target.tabIndex <= this.numberOfFields - 1) {
        let next = evt.target.tabIndex;

        if (evt.target.value && evt.target.tabIndex < this.numberOfFields - 1) {
          next += 1;
        } else if (!evt.target.value && evt.target.tabIndex > 0) {
          next -= 1;
        }

        const element = document.getElementsByName("code_input_" + next)[0];
        if (!noFocusSelect) {
          element.focus();
          element.select();
        }
      }

      this.$emit("input", this.items.join(""));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.input-wrapper {
  padding: 5px;
}

.input {
  font-weight: bold;
  text-align: center;
  margin: 0;
  font-size: 1.3em;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
  }

  @media (max-width: 500px) {
    margin-bottom: 10px;
  }
}
</style>
